<ng-container *skAutorun><sk-designer-wrapper *ngFor="let child of children" [model]="child.contentModel"></sk-designer-wrapper></ng-container>